import React, { useEffect, useState } from 'react';
import { RenderPage } from '@/src/render';
import { store } from '@/src/store/configure';
import { Provider } from 'react-redux';
import { BrowserRouter } from 'react-router-dom';
import styled from 'styled-components';
import { ChartDetails } from './components/ChartDetails';
import { SCHEME_CHART_DURARION_LEVELS } from '@/src/common/enum';

const Container = styled.div`
  width: 100%;
`;

export const GraphSection = () => {
  const [cocode, setCocode] = useState<string | null>(null);
  const [schemeReturnsMap, setSchemeReturnsMap] = useState<
    Record<SCHEME_CHART_DURARION_LEVELS, number | string>
  >({} as Record<SCHEME_CHART_DURARION_LEVELS, number | string>);

  const [inception, setInception] = useState<number | string>('-');

  const extractAttributes = () => {
    const element = document.getElementById('csr-scheme-details-area-chart');
    setCocode(element?.getAttribute('data-mfSchcode') ?? null);
    // eslint-disable-next-line sonarjs/function-return-type
    const getAttributeValue = (attr: string): number | string => {
      const value = element?.getAttribute(attr);
      if (!value || isNaN(parseFloat(value))) {
        return '-';
      }
      return parseFloat(value);
    };

    const newSchemeReturnsMap: Record<
      SCHEME_CHART_DURARION_LEVELS,
      number | string
    > = {
      [SCHEME_CHART_DURARION_LEVELS.ONEMONTH]:
        getAttributeValue('data-oneMonth'),
      [SCHEME_CHART_DURARION_LEVELS.THREEMONTH]:
        getAttributeValue('data-threeMonth'),
      [SCHEME_CHART_DURARION_LEVELS.SIXMONTH]:
        getAttributeValue('data-sixMonth'),
      [SCHEME_CHART_DURARION_LEVELS.ONEYEAR]: getAttributeValue('data-oneYear'),
      [SCHEME_CHART_DURARION_LEVELS.THREEYEAR]:
        getAttributeValue('data-threeYear'),
      [SCHEME_CHART_DURARION_LEVELS.FIVEYEAR]:
        getAttributeValue('data-fiveYear'),
    };
    setSchemeReturnsMap(newSchemeReturnsMap);
    setInception(getAttributeValue('data-inception'));
  };

  useEffect(() => {
    extractAttributes();
  }, []);

  return (
    <Container>
      <ChartDetails
        cocode={cocode}
        schemeReturns={schemeReturnsMap}
        inception={inception}
      />
    </Container>
  );
};

RenderPage(
  'csr-scheme-details-area-chart',
  <Provider store={store}>
    <BrowserRouter>
      <GraphSection />
    </BrowserRouter>
  </Provider>,
);
